var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.777,
    height: 14.171,
    viewBox: "0 0 14.777 14.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14694",
    "data-name": "Group 14694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3786",
    "data-name": "Path 3786",
    d: "M14.609,17.012,8.595,10.958l-.024-.023a1.73,1.73,0,0,0-2.308,0l-.024.023L.17,17.011a.577.577,0,0,0,.815.817l.458-.457v4.984a2.311,2.311,0,0,0,2.309,2.309H5.83a.577.577,0,0,0,.577-.577v-4.7h2.02v4.7A.577.577,0,0,0,9,24.663h2.02a2.311,2.311,0,0,0,2.309-2.309.577.577,0,1,0-1.154,0,1.156,1.156,0,0,1-1.154,1.154H9.582V18.8A.577.577,0,0,0,9,18.227H5.83a.577.577,0,0,0-.577.577v4.7h-1.5A1.156,1.156,0,0,1,2.6,22.354V16.236q0-.009,0-.017l4.443-4.434a.577.577,0,0,1,.749,0l4.39,4.419v3.264a.577.577,0,1,0,1.154,0v-2.1l.456.459a.577.577,0,1,0,.819-.814Z",
    transform: "translate(0 -10.492)",
    fill: "#2c2c2c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.b947534a131eb595ea630b78f2d62bde.svg";
export { ForwardRef as ReactComponent };